import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../../parts/SvgIcon";

const MealPlanSectionCard = ({
  title,
  description,
  count,
  planMode,
  viewPlanText,
}) => {
  const { t } = useTranslation("coaching-portal");

  // Handle view plan button click
  const handleViewPlan = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        planMode,
        page: 1,
        tabView: "meal-plans-tab",
        templateView: "meal-plans",
      },
    });
  };

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: I'm lazy
    // biome-ignore lint/a11y/useKeyWithClickEvents: I'm double lazy lmao
    <div
      className="meal-plan-section-card flex-1 min-w-70 rounded-2xl p-4 flex flex-col justify-between"
      onClick={handleViewPlan}
    >
      <div>
        <h3 className="text-2xl font-bold">{title}</h3>
        <p className="p4 opacity-50 mt-1">{description}</p>
      </div>
      <div className="flex items-center justify-between mt-11">
        <div className="flex items-end">
          <span className="text-[2rem] leading-none">
            {String(count || 0).padStart(2, "0")}
          </span>
          <span className="ml-1 text-xssm uppercase opacity-50">
            {t("allTemplates.chooseASection.plansLabel")}
          </span>
        </div>
        <button
          type="button"
          data-button-type="outline"
          className="view-plan-button"
          onClick={handleViewPlan}
        >
          <span>{viewPlanText}</span>
          <SvgIcon
            src="/img/new-icons/arrow-forward.svg"
            useCurrentColor
            classNames="view-plan-arrow"
          />
        </button>
      </div>
    </div>
  );
};

export default MealPlanSectionCard;
